import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Pratik P Patil aka Percy Riptide`}</h1>
    <p>{`Welcome to my portfolio! I hope you like what you see :D`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      